exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leftInput[data-v-2b67428d] {\n  width: 80%;\n}\n.my-box .my-card[data-v-2b67428d] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-2b67428d] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-2b67428d]:last-child {\n    margin-bottom: 0;\n}\n.my-box .grid-content[data-v-2b67428d] {\n  border-radius: 4px;\n  height: 36px;\n  white-space: nowrap;\n}\n.my-box .grid-content .el-input__inner[data-v-2b67428d] {\n    max-width: 190px;\n}\n.my-box .grid-content span[data-v-2b67428d] {\n    font-size: 14px;\n}\n", ""]);

// exports
